import Cookies from 'js-cookie';

// const configHas = function(name) {
//     const data = Cookies.get('config.' + name)
//     return data != '' && data != undefined && data != 'undefined'
// }


// const confiGet = function(name) {
//     return Cookies.get('config.' + name) == 'true';
// }

const config = {
    title: '授权查询-沉梦云商城',
    /**
     * @type {string} Api地址
     * @description Api地址
     */
    API_URL: 'https://auth.mall.achaci.cn/',
}


export default config


// WEBPACK FOOTER //
// ./src/config.js